import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';

const selectors = {
  LINK: 'a[href]',
  LOADING: 'loading',
  SECTION_ID: 'section-id',
  BREADCRUMB_NAV: 'breadcrumb-nav',
  SHOPIFY_SECTION: '[id^="shopify-section-"]',
  SHOPIFY_SECTION_PREFIX: 'shopify-section-',
};

/**
 * @typedef {Object} Refs
 * @property {HTMLElement} [navigation]
 * @property {HTMLElement} [pagination]
 * @property {HTMLElement} [articles]
 *
 * @extends {Component<Refs>}
 */
class BlogGrid extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = (this.#controller = new AbortController());

    for (const ref of ['navigation', 'pagination']) {
      if (this.refs[ref] instanceof HTMLElement) {
        this.refs[ref].addEventListener('click', this.#handleLinkClick, { signal });
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  get sectionId() {
    return this.getAttribute(selectors.SECTION_ID) ?? '';
  }

  #handleLinkClick = (/** @type {MouseEvent} */ event) => {
    const target = /** @type {Element} */ (event.target);
    if (!target) return;

    const link = /** @type {HTMLAnchorElement | null} */ (target.closest(selectors.LINK));

    if (!link) return;

    event.preventDefault();
    history.pushState({}, '', link.href);

    if (this.refs.articles) this.refs.articles.dataset[selectors.LOADING] = '';

    if (this.refs.pagination?.contains(/** @type {Node} */ (event.target))) {
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    sectionRenderer.renderSection(this.sectionId);

    const breadcrumbsSection = document
      .querySelector(selectors.BREADCRUMB_NAV)
      ?.closest(selectors.SHOPIFY_SECTION);

    if (breadcrumbsSection) {
      sectionRenderer.renderSection(
        breadcrumbsSection.id.replace(selectors.SHOPIFY_SECTION_PREFIX, ''),
      );
    }
  };
}

if (!customElements.get('blog-grid')) {
  customElements.define('blog-grid', BlogGrid);
}
